
    import I18n from 'i18nObj';
    
      import 'translations/modules_home_page';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('modules_home_page');
  